import { render, staticRenderFns } from "./BatchItemAlternateStores.vue?vue&type=template&id=7c3b0c4f"
import script from "./BatchItemAlternateStores.vue?vue&type=script&lang=js"
export * from "./BatchItemAlternateStores.vue?vue&type=script&lang=js"
import style0 from "./BatchItemAlternateStores.vue?vue&type=style&index=0&id=7c3b0c4f&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1176077535/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c3b0c4f')) {
      api.createRecord('7c3b0c4f', component.options)
    } else {
      api.reload('7c3b0c4f', component.options)
    }
    module.hot.accept("./BatchItemAlternateStores.vue?vue&type=template&id=7c3b0c4f", function () {
      api.rerender('7c3b0c4f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BatchItemAlternateStores.vue"
export default component.exports